import {
  faDiscord,
  faFacebook,
  faGithub,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Header, StyledOcticon } from "@primer/components";
import { MarkGithubIcon } from "@primer/octicons-react";
import "../../../scss/_natbar.scss";
import React from "react";

function Navbar() {
  return (
    <>
      <Header className="header">
        <Header.Item>
          <Header.Link href="/" fontSize={2}>
            <StyledOcticon icon={MarkGithubIcon} size={32} mr={2} />
            <span>OpenHackDay Sri Lanka - 2021 - Leaderboard</span>
          </Header.Link>
        </Header.Item>
        <Header.Item full />
        <Header.Link
          href="https://github.com/GitHubExperts-LK"
          target="blank"
          mr={3}
        >
          <FontAwesomeIcon icon={faGithub} />
        </Header.Link>
        <Header.Link
          href="https://www.facebook.com/GitHubCommunityLK"
          target="blank"
          mr={3}
        >
          <FontAwesomeIcon icon={faFacebook} />
        </Header.Link>
        <Header.Link
          href="https://twitter.com/gcsrilanka"
          target="blank"
          mr={3}
        >
          <FontAwesomeIcon icon={faTwitter} />
        </Header.Link>
        <Header.Link
          href="https://www.instagram.com/gcsrilanka/"
          target="blank"
          mr={3}
        >
          <FontAwesomeIcon icon={faInstagram} />
        </Header.Link>
        <Header.Link href="https://discord.gg/uR84QnAC" target="blank" mr={3}>
          <FontAwesomeIcon icon={faDiscord} />
        </Header.Link>
      </Header>
    </>
  );
}

export default Navbar;
